import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchCategories = () => axios.get(`${API}/categories`).then((r) => r.data);
export const fetchProducts = (params) => axios.get(`${API}/products`, { params }).then((r) => r.data);
export const fetchProduct = (id) => axios.get(`${API}/products/${id}`).then((r) => r.data);
export const fetchHome = () => axios.get(`${API}/catalog/home`).then((r) => r.data);
